@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_580_269_951)
internal val Res.drawable.O6F: DrawableResource by lazy {
      DrawableResource("drawable:O6F", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_005_344_742)
internal val Res.drawable.O7: DrawableResource by lazy {
      DrawableResource("drawable:O7", setOf(
        ResourceItem(setOf(), "${MD}drawable/O7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(446_316_755)
internal val Res.drawable.O8: DrawableResource by lazy {
      DrawableResource("drawable:O8", setOf(
        ResourceItem(setOf(), "${MD}drawable/O8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(431_762_306)
internal val Res.drawable.O9: DrawableResource by lazy {
      DrawableResource("drawable:O9", setOf(
        ResourceItem(setOf(), "${MD}drawable/O9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_014_012_879)
internal val Res.drawable.P1: DrawableResource by lazy {
      DrawableResource("drawable:P1", setOf(
        ResourceItem(setOf(), "${MD}drawable/P1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_187_888_363)
internal val Res.drawable.P10: DrawableResource by lazy {
      DrawableResource("drawable:P10", setOf(
        ResourceItem(setOf(), "${MD}drawable/P10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_012_430_994)
internal val Res.drawable.P11: DrawableResource by lazy {
      DrawableResource("drawable:P11", setOf(
        ResourceItem(setOf(), "${MD}drawable/P11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(192_580_208)
internal val Res.drawable.P1A: DrawableResource by lazy {
      DrawableResource("drawable:P1A", setOf(
        ResourceItem(setOf(), "${MD}drawable/P1A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(590_523_329)
internal val Res.drawable.P2: DrawableResource by lazy {
      DrawableResource("drawable:P2", setOf(
        ResourceItem(setOf(), "${MD}drawable/P2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_031_913_519)
internal val Res.drawable.P3: DrawableResource by lazy {
      DrawableResource("drawable:P3", setOf(
        ResourceItem(setOf(), "${MD}drawable/P3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-191_532_443)
internal val Res.drawable.P3A: DrawableResource by lazy {
      DrawableResource("drawable:P3A", setOf(
        ResourceItem(setOf(), "${MD}drawable/P3A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-901_259_748)
internal val Res.drawable.P4: DrawableResource by lazy {
      DrawableResource("drawable:P4", setOf(
        ResourceItem(setOf(), "${MD}drawable/P4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(551_179_432)
internal val Res.drawable.P5: DrawableResource by lazy {
      DrawableResource("drawable:P5", setOf(
        ResourceItem(setOf(), "${MD}drawable/P5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(129_095_867)
internal val Res.drawable.P6: DrawableResource by lazy {
      DrawableResource("drawable:P6", setOf(
        ResourceItem(setOf(), "${MD}drawable/P6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_695_062_814)
internal val Res.drawable.P7: DrawableResource by lazy {
      DrawableResource("drawable:P7", setOf(
        ResourceItem(setOf(), "${MD}drawable/P7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_883_600_422)
internal val Res.drawable.P8: DrawableResource by lazy {
      DrawableResource("drawable:P8", setOf(
        ResourceItem(setOf(), "${MD}drawable/P8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_916_957_959)
internal val Res.drawable.P9: DrawableResource by lazy {
      DrawableResource("drawable:P9", setOf(
        ResourceItem(setOf(), "${MD}drawable/P9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-167_578_371)
internal val Res.drawable.Q1: DrawableResource by lazy {
      DrawableResource("drawable:Q1", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_615_333_568)
internal val Res.drawable.Q2: DrawableResource by lazy {
      DrawableResource("drawable:Q2", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_961_602_902)
internal val Res.drawable.Q3: DrawableResource by lazy {
      DrawableResource("drawable:Q3", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(414_202_372)
internal val Res.drawable.Q4: DrawableResource by lazy {
      DrawableResource("drawable:Q4", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-136_264_189)
internal val Res.drawable.Q5: DrawableResource by lazy {
      DrawableResource("drawable:Q5", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_047_500_773)
internal val Res.drawable.Q6: DrawableResource by lazy {
      DrawableResource("drawable:Q6", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_836_503_511)
internal val Res.drawable.Q7: DrawableResource by lazy {
      DrawableResource("drawable:Q7", setOf(
        ResourceItem(setOf(), "${MD}drawable/Q7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_785_994_564)
internal val Res.drawable.R1: DrawableResource by lazy {
      DrawableResource("drawable:R1", setOf(
        ResourceItem(setOf(), "${MD}drawable/R1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_916_724_623)
internal val Res.drawable.R10: DrawableResource by lazy {
      DrawableResource("drawable:R10", setOf(
        ResourceItem(setOf(), "${MD}drawable/R10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_133_143_664)
internal val Res.drawable.R10A: DrawableResource by lazy {
      DrawableResource("drawable:R10A", setOf(
        ResourceItem(setOf(), "${MD}drawable/R10A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-285_712_145)
internal val Res.drawable.R11: DrawableResource by lazy {
      DrawableResource("drawable:R11", setOf(
        ResourceItem(setOf(), "${MD}drawable/R11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_651_702_771)
internal val Res.drawable.R12: DrawableResource by lazy {
      DrawableResource("drawable:R12", setOf(
        ResourceItem(setOf(), "${MD}drawable/R12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(95_540_701)
internal val Res.drawable.R13: DrawableResource by lazy {
      DrawableResource("drawable:R13", setOf(
        ResourceItem(setOf(), "${MD}drawable/R13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_226_102_065)
internal val Res.drawable.R14: DrawableResource by lazy {
      DrawableResource("drawable:R14", setOf(
        ResourceItem(setOf(), "${MD}drawable/R14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(50_626_991)
internal val Res.drawable.R15: DrawableResource by lazy {
      DrawableResource("drawable:R15", setOf(
        ResourceItem(setOf(), "${MD}drawable/R15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_204_272_977)
internal val Res.drawable.R16: DrawableResource by lazy {
      DrawableResource("drawable:R16", setOf(
        ResourceItem(setOf(), "${MD}drawable/R16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_229_552_152)
internal val Res.drawable.R16A: DrawableResource by lazy {
      DrawableResource("drawable:R16A", setOf(
        ResourceItem(setOf(), "${MD}drawable/R16A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(224_892_669)
internal val Res.drawable.R17: DrawableResource by lazy {
      DrawableResource("drawable:R17", setOf(
        ResourceItem(setOf(), "${MD}drawable/R17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_701_798_611)
internal val Res.drawable.R18: DrawableResource by lazy {
      DrawableResource("drawable:R18", setOf(
        ResourceItem(setOf(), "${MD}drawable/R18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_863_610_771)
internal val Res.drawable.R19: DrawableResource by lazy {
      DrawableResource("drawable:R19", setOf(
        ResourceItem(setOf(), "${MD}drawable/R19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_097_728_685)
internal val Res.drawable.R2: DrawableResource by lazy {
      DrawableResource("drawable:R2", setOf(
        ResourceItem(setOf(), "${MD}drawable/R2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(622_223_049)
internal val Res.drawable.R20: DrawableResource by lazy {
      DrawableResource("drawable:R20", setOf(
        ResourceItem(setOf(), "${MD}drawable/R20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_807_494_468)
internal val Res.drawable.R21: DrawableResource by lazy {
      DrawableResource("drawable:R21", setOf(
        ResourceItem(setOf(), "${MD}drawable/R21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_004_722_298)
internal val Res.drawable.R22: DrawableResource by lazy {
      DrawableResource("drawable:R22", setOf(
        ResourceItem(setOf(), "${MD}drawable/R22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_049_527_893)
internal val Res.drawable.R23: DrawableResource by lazy {
      DrawableResource("drawable:R23", setOf(
        ResourceItem(setOf(), "${MD}drawable/R23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-971_381_163)
internal val Res.drawable.R24: DrawableResource by lazy {
      DrawableResource("drawable:R24", setOf(
        ResourceItem(setOf(), "${MD}drawable/R24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_254_547_131)
internal val Res.drawable.R25: DrawableResource by lazy {
      DrawableResource("drawable:R25", setOf(
        ResourceItem(setOf(), "${MD}drawable/R25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(52_390_750)
internal val Res.drawable.R26: DrawableResource by lazy {
      DrawableResource("drawable:R26", setOf(
        ResourceItem(setOf(), "${MD}drawable/R26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_201_550_250)
internal val Res.drawable.R27: DrawableResource by lazy {
      DrawableResource("drawable:R27", setOf(
        ResourceItem(setOf(), "${MD}drawable/R27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-954_261_865)
internal val Res.drawable.R28: DrawableResource by lazy {
      DrawableResource("drawable:R28", setOf(
        ResourceItem(setOf(), "${MD}drawable/R28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_751_859_609)
internal val Res.drawable.R29: DrawableResource by lazy {
      DrawableResource("drawable:R29", setOf(
        ResourceItem(setOf(), "${MD}drawable/R29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_919_573_283)
internal val Res.drawable.R2A: DrawableResource by lazy {
      DrawableResource("drawable:R2A", setOf(
        ResourceItem(setOf(), "${MD}drawable/R2A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(69_225_311)
internal val Res.drawable.R3: DrawableResource by lazy {
      DrawableResource("drawable:R3", setOf(
        ResourceItem(setOf(), "${MD}drawable/R3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(634_187_917)
internal val Res.drawable.R3A: DrawableResource by lazy {
      DrawableResource("drawable:R3A", setOf(
        ResourceItem(setOf(), "${MD}drawable/R3A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_065_814_638)
internal val Res.drawable.R3B: DrawableResource by lazy {
      DrawableResource("drawable:R3B", setOf(
        ResourceItem(setOf(), "${MD}drawable/R3B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_320_702_211)
internal val Res.drawable.R4: DrawableResource by lazy {
      DrawableResource("drawable:R4", setOf(
        ResourceItem(setOf(), "${MD}drawable/R4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-384_514_048)
internal val Res.drawable.R5: DrawableResource by lazy {
      DrawableResource("drawable:R5", setOf(
        ResourceItem(setOf(), "${MD}drawable/R5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_472_649_243)
internal val Res.drawable.R6: DrawableResource by lazy {
      DrawableResource("drawable:R6", setOf(
        ResourceItem(setOf(), "${MD}drawable/R6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_052_868_060)
internal val Res.drawable.R7: DrawableResource by lazy {
      DrawableResource("drawable:R7", setOf(
        ResourceItem(setOf(), "${MD}drawable/R7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-838_767_185)
internal val Res.drawable.R8: DrawableResource by lazy {
      DrawableResource("drawable:R8", setOf(
        ResourceItem(setOf(), "${MD}drawable/R8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(797_802_015)
internal val Res.drawable.R9: DrawableResource by lazy {
      DrawableResource("drawable:R9", setOf(
        ResourceItem(setOf(), "${MD}drawable/R9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(103_165_537)
internal val Res.drawable.S1: DrawableResource by lazy {
      DrawableResource("drawable:S1", setOf(
        ResourceItem(setOf(), "${MD}drawable/S1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-537_702_158)
internal val Res.drawable.S10: DrawableResource by lazy {
      DrawableResource("drawable:S10", setOf(
        ResourceItem(setOf(), "${MD}drawable/S10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(788_496_227)
internal val Res.drawable.S11: DrawableResource by lazy {
      DrawableResource("drawable:S11", setOf(
        ResourceItem(setOf(), "${MD}drawable/S11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(850_156_266)
internal val Res.drawable.S12: DrawableResource by lazy {
      DrawableResource("drawable:S12", setOf(
        ResourceItem(setOf(), "${MD}drawable/S12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-367_894_604)
internal val Res.drawable.S13: DrawableResource by lazy {
      DrawableResource("drawable:S13", setOf(
        ResourceItem(setOf(), "${MD}drawable/S13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_882_205_760)
internal val Res.drawable.S14: DrawableResource by lazy {
      DrawableResource("drawable:S14", setOf(
        ResourceItem(setOf(), "${MD}drawable/S14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_240_703_729)
internal val Res.drawable.S14A: DrawableResource by lazy {
      DrawableResource("drawable:S14A", setOf(
        ResourceItem(setOf(), "${MD}drawable/S14A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_331_169_300)
internal val Res.drawable.S14B: DrawableResource by lazy {
      DrawableResource("drawable:S14B", setOf(
        ResourceItem(setOf(), "${MD}drawable/S14B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_919_422_191)
internal val Res.drawable.S15: DrawableResource by lazy {
      DrawableResource("drawable:S15", setOf(
        ResourceItem(setOf(), "${MD}drawable/S15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-273_670_994)
internal val Res.drawable.S16: DrawableResource by lazy {
      DrawableResource("drawable:S16", setOf(
        ResourceItem(setOf(), "${MD}drawable/S16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(977_542_916)
internal val Res.drawable.S17: DrawableResource by lazy {
      DrawableResource("drawable:S17", setOf(
        ResourceItem(setOf(), "${MD}drawable/S17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-496_489_849)
internal val Res.drawable.S17A: DrawableResource by lazy {
      DrawableResource("drawable:S17A", setOf(
        ResourceItem(setOf(), "${MD}drawable/S17A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_059_437_138)
internal val Res.drawable.S18: DrawableResource by lazy {
      DrawableResource("drawable:S18", setOf(
        ResourceItem(setOf(), "${MD}drawable/S18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_901_358_632)
internal val Res.drawable.S19: DrawableResource by lazy {
      DrawableResource("drawable:S19", setOf(
        ResourceItem(setOf(), "${MD}drawable/S19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_516_989_394)
internal val Res.drawable.S2: DrawableResource by lazy {
      DrawableResource("drawable:S2", setOf(
        ResourceItem(setOf(), "${MD}drawable/S2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_921_545_199)
internal val Res.drawable.S20: DrawableResource by lazy {
      DrawableResource("drawable:S20", setOf(
        ResourceItem(setOf(), "${MD}drawable/S20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(69_136_788)
internal val Res.drawable.S21: DrawableResource by lazy {
      DrawableResource("drawable:S21", setOf(
        ResourceItem(setOf(), "${MD}drawable/S21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_544_836_815)
internal val Res.drawable.S22: DrawableResource by lazy {
      DrawableResource("drawable:S22", setOf(
        ResourceItem(setOf(), "${MD}drawable/S22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_351_787_105)
internal val Res.drawable.S23: DrawableResource by lazy {
      DrawableResource("drawable:S23", setOf(
        ResourceItem(setOf(), "${MD}drawable/S23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_354_729_936)
internal val Res.drawable.S24: DrawableResource by lazy {
      DrawableResource("drawable:S24", setOf(
        ResourceItem(setOf(), "${MD}drawable/S24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_371_164_545)
internal val Res.drawable.S25: DrawableResource by lazy {
      DrawableResource("drawable:S25", setOf(
        ResourceItem(setOf(), "${MD}drawable/S25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(61_252_039)
internal val Res.drawable.S26: DrawableResource by lazy {
      DrawableResource("drawable:S26", setOf(
        ResourceItem(setOf(), "${MD}drawable/S26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-297_152_100)
internal val Res.drawable.S26A: DrawableResource by lazy {
      DrawableResource("drawable:S26A", setOf(
        ResourceItem(setOf(), "${MD}drawable/S26A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(316_325_896)
internal val Res.drawable.S26B: DrawableResource by lazy {
      DrawableResource("drawable:S26B", setOf(
        ResourceItem(setOf(), "${MD}drawable/S26B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(856_069_864)
internal val Res.drawable.S27: DrawableResource by lazy {
      DrawableResource("drawable:S27", setOf(
        ResourceItem(setOf(), "${MD}drawable/S27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_930_459_425)
internal val Res.drawable.S28: DrawableResource by lazy {
      DrawableResource("drawable:S28", setOf(
        ResourceItem(setOf(), "${MD}drawable/S28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-854_599_857)
internal val Res.drawable.S29: DrawableResource by lazy {
      DrawableResource("drawable:S29", setOf(
        ResourceItem(setOf(), "${MD}drawable/S29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_492_299_507)
internal val Res.drawable.S2A: DrawableResource by lazy {
      DrawableResource("drawable:S2A", setOf(
        ResourceItem(setOf(), "${MD}drawable/S2A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_834_562_894)
internal val Res.drawable.S3: DrawableResource by lazy {
      DrawableResource("drawable:S3", setOf(
        ResourceItem(setOf(), "${MD}drawable/S3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_804_632_308)
internal val Res.drawable.S30: DrawableResource by lazy {
      DrawableResource("drawable:S30", setOf(
        ResourceItem(setOf(), "${MD}drawable/S30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_445_322_849)
internal val Res.drawable.S31: DrawableResource by lazy {
      DrawableResource("drawable:S31", setOf(
        ResourceItem(setOf(), "${MD}drawable/S31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_578_379_219)
internal val Res.drawable.S32: DrawableResource by lazy {
      DrawableResource("drawable:S32", setOf(
        ResourceItem(setOf(), "${MD}drawable/S32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-450_781_847)
internal val Res.drawable.S33: DrawableResource by lazy {
      DrawableResource("drawable:S33", setOf(
        ResourceItem(setOf(), "${MD}drawable/S33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(92_332_118)
internal val Res.drawable.S34: DrawableResource by lazy {
      DrawableResource("drawable:S34", setOf(
        ResourceItem(setOf(), "${MD}drawable/S34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(423_961_565)
internal val Res.drawable.S35: DrawableResource by lazy {
      DrawableResource("drawable:S35", setOf(
        ResourceItem(setOf(), "${MD}drawable/S35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_415_135_579)
internal val Res.drawable.S35A: DrawableResource by lazy {
      DrawableResource("drawable:S35A", setOf(
        ResourceItem(setOf(), "${MD}drawable/S35A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_395_661_657)
internal val Res.drawable.S36: DrawableResource by lazy {
      DrawableResource("drawable:S36", setOf(
        ResourceItem(setOf(), "${MD}drawable/S36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_393_765_771)
internal val Res.drawable.S37: DrawableResource by lazy {
      DrawableResource("drawable:S37", setOf(
        ResourceItem(setOf(), "${MD}drawable/S37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_101_632_214)
internal val Res.drawable.S38: DrawableResource by lazy {
      DrawableResource("drawable:S38", setOf(
        ResourceItem(setOf(), "${MD}drawable/S38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_257_719_842)
internal val Res.drawable.S39: DrawableResource by lazy {
      DrawableResource("drawable:S39", setOf(
        ResourceItem(setOf(), "${MD}drawable/S39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_027_278_164)
internal val Res.drawable.S4: DrawableResource by lazy {
      DrawableResource("drawable:S4", setOf(
        ResourceItem(setOf(), "${MD}drawable/S4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_201_872_504)
internal val Res.drawable.S40: DrawableResource by lazy {
      DrawableResource("drawable:S40", setOf(
        ResourceItem(setOf(), "${MD}drawable/S40.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable7Resources(map: MutableMap<String, DrawableResource>) {
  map.put("O6F", Res.drawable.O6F)
  map.put("O7", Res.drawable.O7)
  map.put("O8", Res.drawable.O8)
  map.put("O9", Res.drawable.O9)
  map.put("P1", Res.drawable.P1)
  map.put("P10", Res.drawable.P10)
  map.put("P11", Res.drawable.P11)
  map.put("P1A", Res.drawable.P1A)
  map.put("P2", Res.drawable.P2)
  map.put("P3", Res.drawable.P3)
  map.put("P3A", Res.drawable.P3A)
  map.put("P4", Res.drawable.P4)
  map.put("P5", Res.drawable.P5)
  map.put("P6", Res.drawable.P6)
  map.put("P7", Res.drawable.P7)
  map.put("P8", Res.drawable.P8)
  map.put("P9", Res.drawable.P9)
  map.put("Q1", Res.drawable.Q1)
  map.put("Q2", Res.drawable.Q2)
  map.put("Q3", Res.drawable.Q3)
  map.put("Q4", Res.drawable.Q4)
  map.put("Q5", Res.drawable.Q5)
  map.put("Q6", Res.drawable.Q6)
  map.put("Q7", Res.drawable.Q7)
  map.put("R1", Res.drawable.R1)
  map.put("R10", Res.drawable.R10)
  map.put("R10A", Res.drawable.R10A)
  map.put("R11", Res.drawable.R11)
  map.put("R12", Res.drawable.R12)
  map.put("R13", Res.drawable.R13)
  map.put("R14", Res.drawable.R14)
  map.put("R15", Res.drawable.R15)
  map.put("R16", Res.drawable.R16)
  map.put("R16A", Res.drawable.R16A)
  map.put("R17", Res.drawable.R17)
  map.put("R18", Res.drawable.R18)
  map.put("R19", Res.drawable.R19)
  map.put("R2", Res.drawable.R2)
  map.put("R20", Res.drawable.R20)
  map.put("R21", Res.drawable.R21)
  map.put("R22", Res.drawable.R22)
  map.put("R23", Res.drawable.R23)
  map.put("R24", Res.drawable.R24)
  map.put("R25", Res.drawable.R25)
  map.put("R26", Res.drawable.R26)
  map.put("R27", Res.drawable.R27)
  map.put("R28", Res.drawable.R28)
  map.put("R29", Res.drawable.R29)
  map.put("R2A", Res.drawable.R2A)
  map.put("R3", Res.drawable.R3)
  map.put("R3A", Res.drawable.R3A)
  map.put("R3B", Res.drawable.R3B)
  map.put("R4", Res.drawable.R4)
  map.put("R5", Res.drawable.R5)
  map.put("R6", Res.drawable.R6)
  map.put("R7", Res.drawable.R7)
  map.put("R8", Res.drawable.R8)
  map.put("R9", Res.drawable.R9)
  map.put("S1", Res.drawable.S1)
  map.put("S10", Res.drawable.S10)
  map.put("S11", Res.drawable.S11)
  map.put("S12", Res.drawable.S12)
  map.put("S13", Res.drawable.S13)
  map.put("S14", Res.drawable.S14)
  map.put("S14A", Res.drawable.S14A)
  map.put("S14B", Res.drawable.S14B)
  map.put("S15", Res.drawable.S15)
  map.put("S16", Res.drawable.S16)
  map.put("S17", Res.drawable.S17)
  map.put("S17A", Res.drawable.S17A)
  map.put("S18", Res.drawable.S18)
  map.put("S19", Res.drawable.S19)
  map.put("S2", Res.drawable.S2)
  map.put("S20", Res.drawable.S20)
  map.put("S21", Res.drawable.S21)
  map.put("S22", Res.drawable.S22)
  map.put("S23", Res.drawable.S23)
  map.put("S24", Res.drawable.S24)
  map.put("S25", Res.drawable.S25)
  map.put("S26", Res.drawable.S26)
  map.put("S26A", Res.drawable.S26A)
  map.put("S26B", Res.drawable.S26B)
  map.put("S27", Res.drawable.S27)
  map.put("S28", Res.drawable.S28)
  map.put("S29", Res.drawable.S29)
  map.put("S2A", Res.drawable.S2A)
  map.put("S3", Res.drawable.S3)
  map.put("S30", Res.drawable.S30)
  map.put("S31", Res.drawable.S31)
  map.put("S32", Res.drawable.S32)
  map.put("S33", Res.drawable.S33)
  map.put("S34", Res.drawable.S34)
  map.put("S35", Res.drawable.S35)
  map.put("S35A", Res.drawable.S35A)
  map.put("S36", Res.drawable.S36)
  map.put("S37", Res.drawable.S37)
  map.put("S38", Res.drawable.S38)
  map.put("S39", Res.drawable.S39)
  map.put("S4", Res.drawable.S4)
  map.put("S40", Res.drawable.S40)
}
